const faqs = [
  {
    q: '51吃瓜网址是什么？有哪些特色栏目？',
    a: '51吃瓜网址是一个专注于娱乐八卦与实时热点的资讯聚合平台，每日更新51今日吃瓜、51吃瓜最新等核心内容。主要栏目包括51吃瓜网今日吃瓜专题、51吃瓜大赛评选、实时快讯追踪以及热门话题讨论，覆盖娱乐圈最新动态，让你随时随地掌握第一手吃瓜资讯。',
  },
  {
    q: '51每日吃瓜的内容多久更新一次？如何确保信息真实性？',
    a: '我们的编辑团队实行7×24小时轮值机制，以分钟级速度追踪全网热点，确保51每日吃瓜内容持续更新不中断。所有爆料信息均经过多渠道交叉验证，标注信息来源与可信度等级，并附上原始信源链接，让每一位瓜友都能放心吃瓜、理性讨论。',
  },
  {
    q: '如何投稿爆料？我的隐私会得到保护吗？',
    a: '你可以通过本站"投稿爆料"专区提交你的独家消息或八卦线索。我们承诺对所有投稿者身份信息严格保密，采用匿名化处理，绝不对外透露任何个人信息。爆料一经核实采用，还将获得首页推荐位展示机会和相应的奖励。',
  },
  {
    q: '51吃瓜大赛是什么活动？如何参与投票？',
    a: '51吃瓜大赛是本站年度重磅评选活动，涵盖年度最大瓜、最佳反转、最意外爆料等十大奖项类别。活动期间，每位注册用户每天拥有5次投票机会，可以为你心中的"年度神瓜"助力打榜。投票结果将在年终盛典直播中揭晓，参与投票还有机会赢取精美礼品。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜问答
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            关于51吃瓜网址的常见问题，帮你快速了解我们的平台与服务
          </p>
        </div>

        <div className="max-w-[800px] mx-auto grid gap-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex-shrink-0 mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}